/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The UpdateUserQuery model module.
 * @module model/UpdateUserQuery
 * @version 0.0.1
 */
class UpdateUserQuery {
    /**
     * Constructs a new <code>UpdateUserQuery</code>.
     * @alias module:model/UpdateUserQuery
     */
    constructor() { 
        
        UpdateUserQuery.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>UpdateUserQuery</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UpdateUserQuery} obj Optional instance to populate.
     * @return {module:model/UpdateUserQuery} The populated <code>UpdateUserQuery</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UpdateUserQuery();

            if (data.hasOwnProperty('longid')) {
                obj['longid'] = ApiClient.convertToType(data['longid'], 'String');
            }
            if (data.hasOwnProperty('label')) {
                obj['label'] = ApiClient.convertToType(data['label'], 'String');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('notes')) {
                obj['notes'] = ApiClient.convertToType(data['notes'], 'String');
            }
            if (data.hasOwnProperty('roles')) {
                obj['roles'] = ApiClient.convertToType(data['roles'], ['String']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>UpdateUserQuery</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UpdateUserQuery</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['longid'] && !(typeof data['longid'] === 'string' || data['longid'] instanceof String)) {
            throw new Error("Expected the field `longid` to be a primitive type in the JSON string but got " + data['longid']);
        }
        // ensure the json data is a string
        if (data['label'] && !(typeof data['label'] === 'string' || data['label'] instanceof String)) {
            throw new Error("Expected the field `label` to be a primitive type in the JSON string but got " + data['label']);
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['notes'] && !(typeof data['notes'] === 'string' || data['notes'] instanceof String)) {
            throw new Error("Expected the field `notes` to be a primitive type in the JSON string but got " + data['notes']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['roles'])) {
            throw new Error("Expected the field `roles` to be an array in the JSON data but got " + data['roles']);
        }

        return true;
    }


}



/**
 * @member {String} longid
 */
UpdateUserQuery.prototype['longid'] = undefined;

/**
 * @member {String} label
 */
UpdateUserQuery.prototype['label'] = undefined;

/**
 * @member {String} email
 */
UpdateUserQuery.prototype['email'] = undefined;

/**
 * @member {String} notes
 */
UpdateUserQuery.prototype['notes'] = undefined;

/**
 * @member {Array.<String>} roles
 */
UpdateUserQuery.prototype['roles'] = undefined;






export default UpdateUserQuery;

